import apiRequest from 'client/helpers/apiRequest';
import { Dataset, Project, Event } from '@interfaces/outreach-entity';

export interface OutreachResponse {
    events: Event[];
    projects: Project[];
    datasets: Dataset[];
}

export const fetchOutreachPage = (): Promise<OutreachResponse> => {
    return apiRequest.get<OutreachResponse>('/api/outreach');
};
